/* eslint-disable */
import React, {useEffect, useState} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useNavigate} from 'react-router-dom';
import {faClipboardList, faSearch, faShoppingBasket, faTimesCircle} from '@fortawesome/free-solid-svg-icons'
import "./tenant.style.css"
import {home, paymentServices} from '../../_services'
import {baseUrl, loadState, numberWithCommas, saveState} from '../../_helpers'
import Loading from '../../component/Loading'
import Layout from '../../component/Layout'
import moment from "moment";
import {toast} from "bulma-toast";
import _ from "lodash";

const Tenant = () => {
    let navigate = useNavigate();
    window.scrollTo(0, 0);
    const [timeOut, setTimeOut] = useState(0)
    const [styletenant, setStyleTenant] = useState("card-tenant")
    const [tenant, setTenant] = useState([]);
    const [search, setSearch] = useState("")
    const [user, setUser] = useState({
        cardNumber: "",
        sessionId: "",
        memberId: "",
        memberType: "",
        memberGroup: "",
        memberName: "",
        tableNo: ""
    })
    const [loading, setLoading] = useState(true)
    const [balance, setBalance] = useState();
    const [errBalance, setErrBalance] = useState();
    useEffect(() =>{
        if (window.location.href.split("/")[4] === "payment" || window.location.href.split("/")[4] === "topup" || window.location.href.split("/")[4] === "voucher-list" || window.location.href.split("/")[4] === "voucher-detail") {
        } else {
            let queryCallback = new Map(window.location.href.substring(1).split("?")[1].split("&").map(el => el.split("=")))
            const payment = queryCallback.get('payment');
            const code = queryCallback.get('code');
            const orderId = queryCallback.get('order_id');
            const transactionStatus = queryCallback.get('transaction_status');
            if (payment === "gopay") {
                localStorage.removeItem('cart');
                localStorage.removeItem('tenantName');
                localStorage.removeItem('item-tenant');
                navigate("/result?message=Berhasil&order_id=" + orderId + "&status_code=" + code + "&transaction_status=" + transactionStatus + "&code=" + code)
            }
        }
    }, [])
    useEffect(() => {
        let format = 'hh:mm:ss'
        let time = moment(new Date(), format),
            beforeTime = moment('10:00:00', format),
            afterTime = moment('21:30:00', format);
        if (time.isBetween(beforeTime, afterTime)) {
            setStyleTenant("card-tenant")
        } else {
            setStyleTenant("card-tenant-opacity")
        }
    })
    /**
     * Query String URL untuk dapatkan parameter
     * @Param Membername mandatory
     * @Param cardNumber mandatory
     * @Param SessionId
     * @Param MemberId mandatory
     * @Param MemberType mandatory (sentul / jgc / bsd)
     * @Param MemberGroup
     * @Param TableNo mandatory
     * */
    let query = new Map(window.location.href.substring(1).split("?")[1].split("&").map(el => el.split("=")))
    useEffect(() => {
        localStorage.clear()
        localStorage.removeItem('menu-sm');
        localStorage.removeItem('product-sm')
        home.getTenant().then(res => {
            const tenantList = _.filter(res.locs, function(o) {
                return o.locationCode.substring(0, 2) !== "FF" && o.locationCode.substring(0, 2) !== "UM" && o.locationCode.substring(0, 3) !== "OFF"
                });
            setTenant(tenantList)
        })
        saveState('memberName', query.get('memberName'))
        saveState('cardNumber', query.get('cardNumber'))
        saveState('sessionId', query.get('sessionId'))
        saveState('memberId', query.get('memberId'))
        saveState('memberType', query.get('memberType'))
        saveState('memberGroup', query.get('memberGroup'))
        saveState('tableNo', query.get('tableNo'))

        // axios.get('https://api.telegram.org/bot437205161:AAEl0E6xpam7r5MUUgyUd_AQcvl4rchUp_0/sendMessage?chat_id=176497627&text=' + query.get('sessionId')).then()

        setUser({
            cardNumber: query.get('cardNumber'),
            sessionId: query.get('sessionId'),
            memberId: query.get('memberId'),
            memberType: query.get('memberType'),
            memberGroup: query.get('memberGroup'),
            tableNo: query.get('tableNo'),
            memberName: query.get('memberName')
        })
        setLoading(true)
        paymentServices.checkBalance(query.get('cardNumber'), query.get('memberType')).then(res => {
            setBalance(res.message)
            setLoading(false)
        }).catch(err => {
            console.log(err)
            setErrBalance(err.data.message)
            setLoading(false)
        })
    }, [])

    const tenantItem = tenant.filter(e => {
        return (
            e.locationName.toLowerCase().indexOf(search.toLocaleLowerCase()) !== -1
        )
    })

    const TenantSelect = (c) => {
        navigate('/menu?locId=' + c.locationId + '&name=' + c.locationName + '&locationCode=' + c.locationCode + '&cardNumber=' + user.cardNumber + '&sessionId=' + user.sessionId + '&memberId=' + user.memberId + '&memberType=' + user.memberType + '&memberGroup=' + user.memberGroup + '&tableNo=' + user.tableNo)
        saveState('locationId', c.locationId)
        if (loadState('locCode') !== c.locationCode) {
            localStorage.removeItem('cart')
            localStorage.removeItem('item-tenant')
            localStorage.removeItem('noteGlobal');
        }
    }

    const onExit = () => {
        navigate("/exit")
        localStorage.clear();
    }

    return (
        <Layout>
            <nav className="navbar navbar-fixed-top background-pink" role="navigation" aria-label="main navigation">
                <div className="navbar-brand ">
                    <div className="py-1 px-1">
                        <div className="control has-icons-right">
                            <input value={search} onChange={(e) => setSearch(e.target.value.toLowerCase())}
                                   className="input is-small is-size-6" type="text" placeholder="Search Store"/>
                            <span className="icon is-right is-size-6">
                            <FontAwesomeIcon icon={faSearch}/>
                        </span>
                        </div>
                    </div>
                    <div className="level is-mobile level-right px-1">
                        <div onClick={() => navigate("/payment")} className="level-item has-text-white"
                             style={{fontSize: "25px"}}>
                            <FontAwesomeIcon icon={faShoppingBasket}/>
                            {loadState('cart') !== undefined && loadState('cart').length > 0 ?
                                <span className="badge-cart">{loadState('cart').length}</span>
                                : ""}
                        </div>
                        <div
                            onClick={() => navigate('/transaction?memberId=' + user.memberId + '&memberType=' + user.memberType + '&memberGroup=' + user.memberGroup)}
                            className="level-item has-text-white"
                            style={{fontSize: "25px"}}>
                            <FontAwesomeIcon icon={faClipboardList}/>
                        </div>
                        <div
                            className="level-item has-text-white"
                            style={{fontSize: "25px"}}
                            onClick={() => onExit()}>
                            <FontAwesomeIcon icon={faTimesCircle}/>
                        </div>
                    </div>
                </div>
            </nav>
            <div className="container tenant px-1">
                <div className="columns">
                    <div className="column">
                        <p className="title-tenant has-text-weight-bold has-text-black">Hi, {query.get('memberName') !== undefined ? query.get('memberName').split("%20").join(" ") : null}</p>
                        <div className="level is-mobile text-bold is-size-5 m-0">
                            {loading ? <Loading/> : errBalance !== undefined ?
                                <p className="has-text-danger">{errBalance}</p> :
                                <>
                                    <div className="level-left">
                                        <div className="level-item">
                                            {/*<button onClick={() => navigate("/topup?memberName=" + user.memberName)}*/}
                                            {/*        className="button is-active" style={{border: 'none', left: '-9%'}}>*/}
                                                <p className="pink" style={{fontSize: 20}}>Saldo saat ini</p>
                                                {/*<div style={{*/}
                                                {/*    marginLeft: 15,*/}
                                                {/*    display: 'flex',*/}
                                                {/*    flexDirection: 'column',*/}
                                                {/*    alignItems: 'center'*/}
                                                {/*}}>*/}
                                                {/*    <FontAwesomeIcon icon={faAngleUp} className="pink" size={15}/>*/}
                                                {/*    <p style={{fontSize: 10}}>Top Up</p>*/}
                                                {/*</div>*/}
                                            {/*</button>*/}
                                        </div>
                                    </div>
                                    <div className="level-right">
                                        <p className="has-text-black">Rp {balance !== undefined ? numberWithCommas(balance.balance) : 0}</p>
                                    </div>
                                </>
                            }
                        </div>
                        <hr/>
                        <div className="py-2">
                            <p className="title-tenant has-text-weight-bold has-text-black">AEON MALL Tenant</p>
                            <p className="description-tenant has-text-grey">Pilih tenant
                                dibawah ini untuk melakukan transaksi</p>
                        </div>
                        <div className="container-card-tenant columns is-mobile">
                            {tenantItem.map((c, i) => (
                                <div key={i}
                                     onClick={() => {
                                         let format = 'hh:mm:ss'
                                         let time = moment(new Date(), format),
                                             beforeTime = moment('10:00:00', format),
                                             afterTime = moment('21:30:00', format);
                                         if (time.isBetween(beforeTime, afterTime)) {
                                             TenantSelect(c)
                                         } else {
                                             if (timeOut === 0) {
                                                 toast({
                                                     message: '<h6 align="center" classname="bold">Pemesanan saat ini telah ditutup <br> silakan coba lagi di jam operasional 10:00 - 21:30</h6>',
                                                     type: "is-danger",
                                                     toastOnce: false,
                                                     position: "center"
                                                 });
                                                 setTimeOut(2000)
                                             }
                                             setTimeout(() => {
                                                 setTimeOut(0)
                                             }, 2000)
                                         }
                                     }}
                                     className="column is-6">
                                    <div className={styletenant}>
                                        <div className="card-image">
                                            <figure className="image is-4by3">
                                                <img
                                                    src={c.locationLogo !== undefined && c.locationLogo !== "" ? `${baseUrl(user.memberType)}` + c.locationLogo : "https://bulma.io/images/placeholders/1280x960.png"}
                                                    alt="Placeholder image"/>
                                            </figure>
                                        </div>
                                        <div className="has-text-centered has-text-black py-1">
                                            {c.description}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Tenant
